/** Parse SharedApp / Request `states` (AWSJSON, comma string, or array). */
function cleanStateEntry(state) {
  const s = String(state).trim();
  if (!s) return null;
  if (/^["']+$/.test(s)) return null;
  return s;
}

export function parseSharedAppStatesRaw(states) {
  if (states == null || states === false) return null;
  if (typeof states === "string") {
    const trimmed = states.trim();
    if (trimmed === "" || trimmed === '""' || trimmed === "''") return null;
    try {
      const parsed = JSON.parse(trimmed);
      if (parsed == null || parsed === "") return null;
      return parsed;
    } catch {
      return trimmed;
    }
  }
  return states;
}

/** Non-empty state codes from a stored states value, or []. */
export function getSharedAppStateEntries(states) {
  const parsed = parseSharedAppStatesRaw(states);
  if (parsed == null) return [];

  let entries = [];
  if (Array.isArray(parsed)) {
    entries = parsed;
  } else if (typeof parsed === "string") {
    entries = parsed.split(",");
  } else {
    entries = [parsed];
  }

  return entries
    .map((state) => cleanStateEntry(state))
    .filter(Boolean);
}

/** True when a partner has a real custom state override (not null/""/[""]). */
export function hasCustomSharedAppStates(states) {
  return getSharedAppStateEntries(states).length > 0;
}

/** State codes from an offer's `states` array. */
export function getOfferStateEntries(states) {
  if (!Array.isArray(states)) return [];
  return states.map((state) => cleanStateEntry(state)).filter(Boolean);
}

/** Normalize request form states to a comma string or null. */
export function normalizeRequestStates(states) {
  if (states == null || states === false || states === "") return null;

  let entries = [];
  if (Array.isArray(states)) {
    entries = states.map((state) => String(state).trim()).filter(Boolean);
  } else if (typeof states === "string") {
    entries = states.split(",").map((state) => state.trim()).filter(Boolean);
  } else {
    return null;
  }

  return entries.length > 0 ? entries.join(",") : null;
}

/** Serialize for DynamoDB AWSJSON — null clears custom states (never JSON ""). */
export function serializeSharedAppStates(states) {
  const entries = getSharedAppStateEntries(states);
  if (entries.length === 0) return null;
  const cleaned = entries.join(",").replace(/\s/g, "");
  return cleaned ? JSON.stringify(cleaned) : null;
}
